<breadcrumb-layout>
<li>
	<breadcrumb-item-view (action)="goToLicenseManagement()">{{'license-management' | translate}}</breadcrumb-item-view>
</li>
@if ((breadcrumbStateService.navState$ | async) === States.LICENSE_SEATS_MANAGEMENT) {
  <li>
	<breadcrumb-item-view>
	  <span translate="license-management_seat-management"></span>
	</breadcrumb-item-view>
  </li>
}
</breadcrumb-layout>
